import moment from 'moment'
import { UseCaseTypes } from '../../../../../constants/blogUseCase'
import { generateBlogPostSlug, generateSecondaryBlogSlug } from '../../../../../utils/blog.utils'

export const fillInBlogFields = (post: any, useCase: string, defaultLocale: string) => {
  const date = post.date ? new Date(post.date) : ''
  const isMainBlog = useCase === UseCaseTypes.MAIN_BLOG

  const postData = {
    src: post.mainImage?.image?.file?.url || '',
    altText: post.mainImage?.altText || '',
    date: date ? moment(date).format('MMMM DD, YYYY') : '',
    title: post.h1Title || '',
    subtitle: '',
    category: post.blogCategory?.title || '',
    link: '',
  }

  if (post.blogCategory?.title === 'Robotic Process Automation (RPA)') {
    postData.category = 'RPA'
  } else if (post.blogCategory?.title === 'Artificial Intelligence (AI)') {
    postData.category = 'AI'
  }

  if (post.teaserBody?.raw) {
    postData.subtitle = post.teaserBody.raw
  } else if (post.seo?.pageMetaDescription) {
    postData.subtitle = post.seo.pageMetaDescription
  }

  if (post.slug && post.blogCategory?.title) {
    let categoryId = post.blogCategory.title
    if (post.blogCategory.overwriteUrlText) categoryId = post.blogCategory.overwriteUrlText

    let blogCategoryPath = categoryId
      .toLowerCase()
      .replace(/ *\([^)]*\) */g, '')
      .replace(/\s/g, '-')

    if (blogCategoryPath) {
      if (blogCategoryPath === 'artificial-intelligence') {
        blogCategoryPath = 'ai'
      } else if (blogCategoryPath === 'robotic-process-automation') {
        blogCategoryPath = 'rpa'
      }
    }

    if (!isMainBlog) {
      postData.link = generateSecondaryBlogSlug({
        slug: post.slug,
        blogCategoryName: blogCategoryPath,
        useCase,
        pageLocale: defaultLocale,
      })
    } else {
      postData.link = generateBlogPostSlug({
        slug: post.slug,
        blogCategoryName: blogCategoryPath,
        pageLocale: defaultLocale,
      })
    }
  }

  return postData
}
